import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import Auth from 'views/auth/Auth';
import ResetPassword from 'views/auth/ResetPassword';
import Layout from 'components/layouts/main/Layout';
import { getAllAccess, getUser } from 'localStorage/authStorage';
import { GeotileMapContextProvider } from 'views/geotileMap/GeotileMapContext';
import { GeotileMap } from 'views/geotileMap/GeotileMap';
import Vehicles from 'views/vehicles/Vehicles';
import Companies from 'views/user-management/Companies';
import Users from 'views/user-management/Users';
import Geofences from 'views/geofence/Geofences';
import ApiKeys from 'views/api-keys/ApiKeys';
import Dashboard from 'views/dashboard/Dashboard';
import { CompanyRole } from 'models/companies/enums/companies.enums';
import RequireAdmin from 'components/hocs/RequireAdmin';
import RequireClient from 'components/hocs/RequireClient';
import RequireAssetsAccess from 'components/hocs/RequireAssetsAccess';
import { getPostLoginPath } from 'models/shared/helpers/postLoginRedirect';

function RequireAuth({ children }: { children: JSX.Element }) {
	if (!getAllAccess()) {
		return <Navigate to="/auth" />;
	}
	return children;
}

function OpenDefault() {
	const user = getUser();
	if (user) {
		return <Navigate to={getPostLoginPath(user)} replace />;
	}
	return <Navigate to="/auth" />;
}

const layoutRoutes = [
	{
		path: '/map',
		element: (
			<GeotileMapContextProvider>
				<GeotileMap />
			</GeotileMapContextProvider>
		),
	},
	{
		path: '/dashboard',
		element: (
			<RequireClient>
				<Dashboard />
			</RequireClient>
		),
	},
	{
		path: '/assets',
		element: (
			<RequireAssetsAccess>
				<Vehicles />
			</RequireAssetsAccess>
		),
	},
	{
		path: '/companies',
		element: (
			<RequireAdmin>
				<Companies />
			</RequireAdmin>
		),
	},
	{
		path: '/users',
		element: (
			<RequireAdmin>
				<Users />
			</RequireAdmin>
		),
	},
	{
		path: '/geofences',
		element: (
			<RequireAdmin>
				<Geofences />
			</RequireAdmin>
		),
	},
	{
		path: '/api-keys',
		element: (
			<RequireAdmin>
				<ApiKeys />
			</RequireAdmin>
		),
	},
];

function RootRouter() {
	return (
		<BrowserRouter>
			<CssBaseline />
			<Routes>
				<Route path="auth" element={<Auth type={CompanyRole.CLIENT} />} />
				<Route path="reset-password" element={<ResetPassword />} />
				<Route
					element={
						<RequireAuth>
							<Layout />
						</RequireAuth>
					}
				>
					{layoutRoutes.map((route) => (
						<Route key={route.path} path={route.path} element={route.element} />
					))}
				</Route>
				<Route path="*" element={<OpenDefault />} />
			</Routes>
		</BrowserRouter>
	);
}
export default RootRouter;
